module.exports = __webpack_public_path__ + "catalog/items/metal-detector/display2.png";